import { Route, useLocation } from "react-router";
import { Redirect } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { MobileRouterPaths } from "../mobileAppConstants.js";
import { makeSelectAppLoggedIn } from "../../app/appSelectors.js";
import Cookies from "universal-cookie";
import MobileMenu from "./MobileMenu.jsx";
import React, { useMemo } from "react";
import { MobileContentStyled } from "./styled/MobileAppStyled.js";
import LiteTradeProvider from "../../providers/LiteTradeProvider/LiteTradeProvider.jsx";
import MobileSliderPrivatePages from "./MobileSliderPages/MobileSliderPrivatePages";

const browserCookies = new Cookies();

function MobileAppPrivateRoute(props) {
    const {isLoggedIn, ...rest} = props;
    const location = useLocation();
    const isFirstStart = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return params.get('app_first_start');
    }, [location.search]);

    if (isFirstStart && !isLoggedIn && rest.path === MobileRouterPaths.default) {
        return <Redirect to={{
            pathname: MobileRouterPaths.firstStart,
            search: location.search,
            state: {
                originPathname: location.pathname,
                originSearch: location.search
            }
        }}/>
    }

    if (!isLoggedIn) {
        return <Redirect to={{
            pathname: MobileRouterPaths.login,
            search: location.search,
            state: {
                originPathname: location.pathname,
                originSearch: location.search
            }
        }}/>
    }

    if (!browserCookies.get('pinOk')) {
        return <Redirect to={{
            pathname: MobileRouterPaths.auth,
            search: location.search,
            state: {
                originPathname: location.pathname,
                originSearch: location.search
            }
        }}/>
    }

    return <>
        <LiteTradeProvider/>
        <MobileContentStyled>
            <Route {...rest}/>
        </MobileContentStyled>
        <MobileMenu/>
        <MobileSliderPrivatePages/>
    </>;
}

const mapStateToProps = createStructuredSelector({
    isLoggedIn: makeSelectAppLoggedIn(),
});

export default connect(mapStateToProps)(MobileAppPrivateRoute);
